/** Display message box when no hazards present and has message  */
export function HazardsNoneMessageTab({ hazardTextLong }: { hazardTextLong?: string }) {
  if (!hazardTextLong) {
    // has hazards so dont display message or has no message for no hazards
    return null;
  }

  return (
    <div
      data-comp="hazard-none-msg"
      className={`u-mT-xs u-pT-0 u-pB-xs national-parks-grey Accordian-message-grey--national-parks`}
    >
      <div className="u-pT-xs upB-xs u-text-sm u-mL-xs">{hazardTextLong}</div>
    </div>
  );
}
